import ProductSettings from './ProductSettings';

export default ProductSettings;
